import { createFileRoute } from '@tanstack/react-router'

import { PaginaConfiguracoes } from '@/features/configuracoes/pagina'

export const Route = createFileRoute('/$perfil/configuracoes')({
  component: Tela,
})

function Tela() {
  return <PaginaConfiguracoes />
}
